import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SetPassword from '../views/SetPassword.vue'
import Privacy from '../views/Privacy.vue'
import PrivacyCGA from '../views/PrivacyCGA.vue'
import PrivacySettings from '../views/PrivacySettings.vue'

import ResetPassword from '../views/ResetPassword.vue'
import LostPassword from '../views/LostPassword.vue'
import LostPasswordConfirm from '../views/LostPasswordConfirm.vue'

import Profile from '../views/Profile.vue'
import Login from '../views/Login.vue'
import OurNetwork from '../views/OurNetwork.vue'
import AboutUs from '../views/AboutUs.vue'
import EmergencyAssistance from '../views/24HEmergency.vue'
import GeneralContacts from '../views/GeneralContacts.vue'
import GeneralContactsSuccess from '../views/GeneralContactsSuccess.vue'
import EmergencyEmail from '../views/EmergencyEmail.vue'
import EmergencyEmailSuccess from '../views/EmergencyEmailSuccess.vue'

/* INSURANCE HIGHLIGHTS */
import InsuranceHighlights from '../views/InsuranceHighlights.vue'
import TravelAssistance from '../views/highlights/TravelAssistance.vue'
import MedicalExpenses from '../views/highlights/MedicalExpenses.vue'
import PersonalAccident from '../views/highlights/PersonalAccident.vue'
import ThirdPartyLiability from '../views/highlights/ThirdPartyLiability.vue'
import TravelInconveniences from '../views/highlights/TravelInconveniences.vue'
import CoverStay from '../views/highlights/CoverStay.vue'

import PageNotFound from '../views/PageNotFound.vue'

/* CLAIM */
import FileClaim from '../views/FileClaim.vue'
import FileClaimEnd from '../views/FileClaimEnd.vue'
import PrivacyClaim from '../views/PrivacyClaim.vue'
import ClaimDocumentation from '../views/ClaimDocumentation.vue'


//import ClaimStepper from '../views/claim/ClaimStepper'
//import OpenClaim from '../views/claim/OpenClaim.vue'
//import Accident from '../views/claim/Accident.vue'
//import MedicalExpenses from '../views/claim/MedicalExpenses.vue'
//import ThirdPartyLiability from '../views/claim/ThirdPartyLiability.vue'
//import TravelCancellation from '../views/claim/TravelCancellation.vue'
//import TravelInterruption from '../views/claim/TravelInterruption.vue'
//import TravelIncovenience from '../views/claim/TravelIncovenience.vue'
//import CoverStay from '../views/claim/CoverStay.vue'
//import MedicalExpenses from '../views/claim/CoverStay.vue'

/* CLAIM - end */
import OnboardLayout from '../layouts/OnboardLayout.vue'
import MainLayout from '../layouts/MainLayout.vue'
//import BlackLayout from '../layouts/BlackLayout.vue'

import store from '../store';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        name: 'Home',
        path: '',
        component: Home,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  // Onboard - inizio
  {
    path: '/password/:verificationToken/:user',
    component: OnboardLayout,
    children: [
      {
        name: 'SetPassword',
        path: '',
        component: SetPassword,
      },
    ],
    meta: { 
      verifyToken: true
    }
  },
  {
    path: '/privacy',
    
    component: OnboardLayout,
    children: [
      {
        name: 'Privacy',
        path: '',
        component: Privacy,
      },
      {
        name: 'PrivacyCGA',
        path: 'cga',
        component: PrivacyCGA,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  // Onboard - fine
  {
    path: '/lost-password',
    component: OnboardLayout,
    children: [
      {
        name: 'LostPassword',
        path: '',
        component: LostPassword,
      },
    ],
  },
  {
    path: '/lost-password-confirm',
    component: OnboardLayout,
    children: [
      {
        name: 'LostPasswordConfirm',
        path: '',
        component: LostPasswordConfirm,
      },
    ],
  },
  {
    path: '/reset-password/:verificationToken/:user',
    component: OnboardLayout,
    children: [
      {
        name: 'ResetPassword',
        path: '',
        component: ResetPassword,
      },
    ],
    meta: { 
      verifyToken: true
    }
  },

  {
    path: '/login',
    component: OnboardLayout,
    children: [
      {
        name: 'Login',
        path: '',
        component: Login,
      },
    ],
  },  
  {
    path: '/me',
    component: MainLayout,
    children: [
      {
        name: 'Profile',
        path: '',
        component: Profile,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/insurance',
    component: MainLayout,
    children: [
      {
        name: 'InsuranceHighlights',
        path: '',
        component: InsuranceHighlights,
      },
      {
        name: 'TravelAssistance',
        path: 'travel-assistance',
        component: TravelAssistance,
      },
      {
        name: 'MedicalExpenses',
        path: 'medical-expenses',
        component: MedicalExpenses,
      },
      {
        name: 'PersonalAccident',
        path: 'personal-accident',
        component: PersonalAccident,
      },
      {
        name: 'ThirdPartyLiability',
        path: 'tpl',
        component: ThirdPartyLiability,
      },
      {
        name: 'TravelInconveniences',
        path: 'travel-inconveniences',
        component: TravelInconveniences,
      },
      {
        name: 'CoverStay',
        path: 'cover-stay',
        component: CoverStay,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  /*{
    path: '/insurance-detail',
    component: MainLayout,
    children: [
      {
        name: 'InsuranceDetail',
        path: '',
        component: InsuranceDetail,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },*/
  {
    path: '/about-us',
    component: MainLayout,
    children: [
      {
        name: 'AboutUs',
        path: '',
        component: AboutUs,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/contact-us',
    component: MainLayout,
    children: [
      {
        name: 'GeneralContacts',
        path: '',
        component: GeneralContacts,
      },
      {
        name: 'GeneralContactsSuccess',
        path: 'success',
        component: GeneralContactsSuccess,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/emergency-email',
    component: MainLayout,
    children: [
      {
        name: 'EmergencyEmail',
        path: '',
        component: EmergencyEmail,
      },
      {
        name: 'EmergencyEmailSuccess',
        path: 'success',
        component: EmergencyEmailSuccess,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/24h-emergency',
    component: MainLayout,
    children: [
      {
        name: '24HEmergency',
        path: '',
        component: EmergencyAssistance,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/file-claim-end/:claimId',
    component: MainLayout,
    children: [
      {
        name: 'FileClaimEnd',
        path: '',
        component: FileClaimEnd,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/file-claim',
    component: MainLayout,
    children: [
      {
        name: 'FileClaim',
        path: '',
        component: FileClaim,
      },
      {
        name: 'PrivacyClaim',
        path: 'privacy',
        component: PrivacyClaim,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/privacy/manage',
    component: MainLayout,
    children: [
      {
        name: 'PrivacySettings',
        path: '',
        component: PrivacySettings,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/claim-documentation',
    component: MainLayout,
    children: [
      {
        name: 'ClaimDocumentation',
        path: '',
        component: ClaimDocumentation,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/elite/our-network',
    component: MainLayout,
    children: [
      {
        name: 'OurNetwork',
        path: '',
        component: OurNetwork,
      },
    ],
    meta: { 
      requiresAuth: true
    }
  },
  { 
    path: '*', 
    component: PageNotFound,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  //console.log(to, from);
  if(store.state.menuIsOpen){
    store.dispatch('toggleMenu');
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {
    //console.log("requiresAuth");
    if (store.getters.isLoggedIn) {
      //console.log("isLoggedIn!");
      if(!store.getters.privacyAccepted && to.name != 'Privacy'){
        //console.log("privacy");
        next('/privacy')
        return
      }
      if(store.getters.privacyAccepted && !store.getters.privacyCgaAccepted && to.name != 'PrivacyCGA'){
        //console.log("privacy cga");
        next('/privacy/cga')
        return 
      }
      //console.log("next", to, from);
      next()
      return
    }
    //console.log("redirect to login");
    next('/login')
    return 
  } 
  if(to.matched.some(record => record.meta.verifyToken)) {
    //console.log("verifyToken");
    window.localStorage.clear();
    store.dispatch('checkVerificationToken', to.params.verificationToken)
      .then(() => {
        next()
        return
      })
      .catch(() => {
        next('/login');
        return
      });
  }
  else {
    next() 
    return
  }
})

export default router
